






























import { NotificationStoreHelper, RootStoreHelper } from '../../../core/mixins';
import { Component, Emit, Inject, Mixins, Prop } from 'vue-property-decorator';
import { IDescription, Point, PointsOfInterest } from '../../../core/models';
import { OptionalCompanyID } from '../../../core/utils';
import { TrackingService } from '../../../core/api';
import { MarkStateStore } from './marks.state';
import ManagementGeofences from './ManagementGeofences.vue';

@Component<PointsOfInterestTabItem>({
    components: { ManagementGeofences },
    subscriptions() {
        return {
            elements$: this.pointStore.filterElements$,
            selected$: this.pointStore.selected$,
            loading$: this.pointStore.selectLoading(),
            filter$: this.pointStore.filter$
        };
    }
})
export default class PointsOfInterestTabItem extends Mixins(NotificationStoreHelper, RootStoreHelper) {
    elements$: PointsOfInterest[];
    selected$: PointsOfInterest[];
    filter$: string;
    loading$: boolean;
    errorState: boolean = false;
    loadingDelete: boolean = false;
    @Prop() companySelected: OptionalCompanyID;
    @Inject() pointStore: MarkStateStore<PointsOfInterest>;
    @Prop() tab: string;
    pointOfInterestText: string = 'punto de interes'

    handleSelectElements(selectedElements: PointsOfInterest[]): void {
        this.pointStore.setSelected(selectedElements);
    }

    handleAddSelectElement(selectedElement: PointsOfInterest, selected: boolean) {
        this.pointStore.addSelectElement(selectedElement, selected, 'point_of_interest_id');
    }

    handleChangeFilter(filter: string): void {
        this.pointStore.setFilter(filter);
    }

    refreshPointsOfInterestAfterFileUpload(): void {
        this.loadData();
    }

    loadData(): void {
        if (this.companySelected !== null) {
            this.errorState = false;
            this.pointStore.updateLoading(true);
            TrackingService.getPointsOfInterestByCompany(this.companySelected as string, this.$_isMock)
                .then((response: PointsOfInterest[]) => {
                    this.pointStore.updateLoading(false);
                    this.pointStore.setElements(response);
                })
                .catch(error => {
                    this.pointStore.updateLoading(false);
                    this.errorState = true;
                    this.$_errorDeleteGeofences(error.message);
                });
        }
    }

    handleDeleteElements(elements: PointsOfInterest[]): void {
        const ids = elements.map(points => `${points.point_of_interest_id}`);
        this.loadingDelete = true;
        TrackingService.deletePointsOfInterest(ids)
            .then(response => {
                if ((response && response['status'] === 200) || response['status'] === 204) {
                    if (response['data'] && response['data'].message) {
                        this.$_showDeleteGeofences(response['data'].message);
                    } else {
                        this.$_showDeleteGeofences('Eliminado correctamente');
                    }
                    this.pointStore.setSelected([]);
                    this.pointStore.removeElements(elements, 'point_of_interest_id');
                } else {
                    this.$_errorDeleteGeofences('Problema eliminando');
                }
                this.loadingDelete = false;
                this.managementGeofences.setOpenConfirmation(false);
            })
            .catch(error => {
                this.$_errorDeleteGeofences(error.message);
                this.loadingDelete = false;
                this.managementGeofences.setOpenConfirmation(false);
            });
    }

    get managementGeofences(): any {
        return this.$refs.managementGeofences;
    }

    @Emit()
    center(point: Point) {}

    handleCenter(centerElement: PointsOfInterest): void {
        this.center(centerElement.point);
    }

    @Emit()
    waitForAddPoint(): void {}

    @Emit()
    waitForEditPoint(point: PointsOfInterest): void {}
}
